import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';
import uniq from 'lodash/uniq';
import findParentLevel from 'lib/seatmaps/findParentLevel';

function collectZones(group) {
  return group.reduce(function(arr, item) {
    item.data && arr.push(item.data.zone_no);
    return arr;
  }, []);
}

/**
 * Returns an array of uniqe zones per level
 * A 'level' in this case is a layer in the
 * provided seat-map SVG.
 */
export default function collectZonesByLevel(collectedSeats) {
  let groupedByLevel = groupBy(collectedSeats, function(seat) {
    return findParentLevel(seat.el).id;
  });

  let zonesByLevel = reduce(
    groupedByLevel,
    function(acc, group, key) {
      let zones = uniq(collectZones(group));
      if (!acc[key]) {
        acc[key] = zones;
      }
      return acc;
    },
    {}
  );

  return zonesByLevel;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seatmaps/collectZonesByLevel.js